import script from "./EditBankPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBankPage.vue?vue&type=script&setup=true&lang=js"

import "./EditBankPage.vue?vue&type=style&index=0&id=1cccbfbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cccbfbc"]])

export default __exports__